export default __webpack_public_path__ + "af45e113464336f2774f53411c10c047.ttf";